import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../../common/components/Icon/Icon";

interface OrderEmailFormProps {
  onSubmit: (email: string) => void;
}

const OrderEmailForm: React.FC<OrderEmailFormProps> = ({ onSubmit }) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError(
        t("validation.emailInvalid", "Please enter a valid email address.")
      );
      return;
    }
    onSubmit(email);
  };

  return (
    <div className="order-page-container">
      <div className="order-page__email-form-wrapper">
        <div className="order-page__header">
          <Icon iconName="lock-closed" className="icon--stroke-thickest" />
          <h1 className="order-page__title">
            {t("orderPage.verifyTitle", "Verify Your Order")}
          </h1>
          <p className="order-page__subtitle">
            {t(
              "orderPage.verifyMessage",
              "Please enter the billing email address used for this order to view details."
            )}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="order-page__email-form">
          <div className="form-field">
            <label htmlFor="order-email" className="sr-only">
              {t("checkoutForm.fields.email", "Email Address")}
            </label>
            <input
              type="email"
              id="order-email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError("");
              }}
              placeholder={t(
                "checkoutForm.fields.email",
                "Enter your billing email"
              )}
              className={`form-field__input ${error ? "has-error" : ""}`}
            />
            {error && <p className="form-field__error">{error}</p>}
          </div>

          <button type="submit" className="order-page__button">
            {t("orderPage.verifyButton", "View Order")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default OrderEmailForm;
